<template>
    <div id="loading">
        <van-loading type="spinner"></van-loading>
        <p class="message" v-if="message">{{ message }}</p>
    </div>
</template>

<script>
import { Loading } from 'vant';

export default {
    name: 'LoadingComponent',
    components: {
        [Loading.name]: Loading
    },
    props: {
        message: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>
#loading {
    position: fixed;
    z-index: 10000;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.6);
    :deep(.van-loading__spinner) {
        width: 80px;
        height: 80px;
    }
    .message {
        opacity: 0.6;
        color: white;
        font-size: 30px;
        margin-top: 30px;
    }
}
</style>
